import Flickity from 'flickity';

const initShowcase = (section) => {
    const sectionInner = section.querySelector('.js-showcase-inner');
    const track = section.querySelector('.js-track');
    const filmCards = section.querySelectorAll('.play-film-card');
    const mediaItems = section.querySelectorAll('.js-media-list-item');

    if (!sectionInner) return;

    const flickityOptions = {
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        setGallerySize: true,
        watchCSS: true
    };

    const carousel = new Flickity(track, flickityOptions);

    carousel.on('select', (index) => {
        mediaItems.forEach((item, i) => {
            item.classList.toggle('is-active', i === index);
        });
    });

    // Disable click events on drag
    carousel.on('dragStart', () => { carousel.slider.style.pointerEvents = 'none'; });
    carousel.on('dragEnd', () => { carousel.slider.style.pointerEvents = 'auto'; });

    filmCards.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => {
            const index = [...filmCards].indexOf(trigger);

            mediaItems.forEach((item) => item.classList.remove('is-active'));

            if (mediaItems[index]) {
                mediaItems[index].classList.add('is-active');
            }
        });
    });
};

export default initShowcase;
